
const digest = '24ba4954c806d74b26de49e96f72c5f9fd0d8e90aad015115e82c18f6ecc12b7';
const classes = {"wrapper":"_wrapper_128i8_1"};
const css = `._wrapper_128i8_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  